import { Phone, ShieldCheck } from "lucide-react";

const APPLICATION_URL = "https://secure.dominionlending.ca/?app=25574&lang=en";

export default function MobileCTA({ onLead }) {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="fixed bottom-0 inset-x-0 z-40 lg:hidden bg-charcoal/85 backdrop-blur-xl border-t border-gold/25 p-3 flex gap-2.5"
    >
      <a
        href="tel:+18257362193"
        data-testid="mobile-call-akashdeep-btn"
        aria-label="Call Akashdeep"
        className="flex-1 inline-flex items-center justify-center gap-1.5 py-4 text-[10px] tracking-[0.14em] font-semibold text-gold border border-gold/50 active:bg-gold/10 transition-colors duration-300 rounded-sm"
      >
        <Phone size={13} strokeWidth={1.75} /> CALL
      </a>
      <a
        href={APPLICATION_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-apply-btn"
        aria-label="Start your secure online application"
        className="flex-1 inline-flex items-center justify-center gap-1.5 py-4 text-[10px] tracking-[0.14em] font-semibold text-gold border border-gold/50 active:bg-gold/10 transition-colors duration-300 rounded-sm"
      >
        <ShieldCheck size={13} strokeWidth={1.75} /> APPLY
      </a>
      <button
        data-testid="mobile-get-preapproved-btn"
        onClick={() => onLead("pre-approval")}
        className="flex-1 py-4 text-[10px] tracking-[0.14em] font-semibold text-charcoal bg-gold active:bg-champagne transition-colors duration-300 rounded-sm"
      >
        PRE-APPROVED
      </button>
    </div>
  );
}
